import { render, staticRenderFns } from "./CartaoAssociado.vue?vue&type=template&id=d656536a&"
import script from "./CartaoAssociado.vue?vue&type=script&lang=js&"
export * from "./CartaoAssociado.vue?vue&type=script&lang=js&"
import style0 from "./CartaoAssociado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports